module.exports = __webpack_public_path__ + "img/project-7.f9ca5e3b.png";